export const AUTH_HERO_IMAGE_URLS = [
  "https://media.wired.com/photos/5a0e6fe27d6fd0312d8bba41/master/w_1600%2Cc_limit/Roadster_Hero.jpg",
  "https://i.pinimg.com/originals/04/e4/66/04e466bd0570efcd87050c560dbccf03.jpg",
  "https://i.imgur.com/D6jOaxB.jpg",
  "https://cdn.motor1.com/images/mgl/NGOMej/s1/bmw-i5-edrive40-2023.jpg",
];

export const AUTH_HERO_SLOGANS = [
  "The Future of Automotive: Seamless Experience, Limitless Efficiency.",
  "From Digital to Dealership: One Seamless Customer Journey on a Single Platform.",
  "Maximum Profit in F&I, Complete Confidence in Your Operations.",
  "Simplify Complex IT, Focus on Your Business.",
  "From Data to Intelligence, Sales to Service: The Full Power of Your Dealership on One Platform.",
  "Every Moment Profitable, Every Process Smart: Master Your Dealership's Digital Transformation.",
];
